<template>
  <div class="nb-header">
    <header>
      <div class="header-logo">
        <div
          class="nb-logo"
          style="color: #fff;
    width: 7.125em;
    height: 1.75em;"
        >
          <svg
            aria-label="logo simple"
            aria-labelledby="logoLabel"
            viewBox="0 0 114 24.9"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            role="img"
            style="pointer-events: none; display: block; width: 100%; height: 100%;"
          >
            <!-- eslint-disable max-len -->
            <title id="logoLabel">Fidelity NetBenefits</title>
            <g>
              <path
                class="st0"
                d="M3.5,12.1h6.1l0.6,7.6h0l2.1-7.6h4l-3.5,12.6H6.8l-0.7-7.4h0l-2,7.4H0L3.5,12.1z"
              />
              <path
                class="st0"
                d="M25.4,21.4c-0.2,0.9-1.4,2.3-2.7,2.9c-1.4,0.6-2.7,0.7-3.7,0.7c-4.4,0-4.9-2-4-5.1c0.8-3.1,2.6-5.1,7-5.1
                c4.5,0,4.7,1.9,3.7,5.6h-6.5c-0.6,2-0.4,2.2,0.6,2.2c0.8,0,1.2-0.4,1.5-1.2H25.4z M22.1,18.6c0.2-0.8,0.2-1.6-0.8-1.6
                c-1,0-1.4,0.8-1.7,1.6H22.1z"
              />
              <path
                class="st0"
                d="M28.3,15l0.6-2.1h4.6L32.9,15h1.9l-0.6,2.1h-1.9l-1.1,4c-0.2,0.7,0.1,1.2,0.6,1.2h0.9l-0.6,2.3h-4.5
                c-1.3,0-1.7-1-1.5-1.9l1.5-5.5h-0.9l0.6-2.1H28.3z"
              />
              <path
                class="st0"
                d="M36.2,12.1h6.6c3.6,0,4.3,1.1,3.8,3c-0.6,2.1-2,2.8-3.9,3.1l0,0c1.9,0.2,3,1,2.4,3.1c-0.4,1.6-1.8,3.2-4.9,3.2
                h-7.4L36.2,12.1z M38,22h1c0.7,0,1.3-0.7,1.5-1.4c0.2-0.8-0.1-1.1-0.7-1.1h-1L38,22z M39.4,17h1c0.6,0,1.1-0.5,1.3-1.2
                c0.2-0.6,0-1.2-0.6-1.2h-1L39.4,17z"
              />
              <path
                class="st0"
                d="M56.4,21.4c-0.2,0.9-1.4,2.3-2.7,2.9c-1.4,0.6-2.7,0.7-3.7,0.7c-4.4,0-4.9-2-4-5.1c0.8-3.1,2.6-5.1,7-5.1
                c4.5,0,4.7,1.9,3.7,5.6h-6.5c-0.6,2-0.4,2.2,0.6,2.2c0.8,0,1.2-0.4,1.5-1.2H56.4z M53,18.6c0.2-0.8,0.2-1.6-0.8-1.6
                c-1,0-1.4,0.8-1.7,1.6H53z"
              />
              <path
                class="st0"
                d="M58.9,15h4.5l-0.5,1.6h0c1.1-1.4,2.1-1.9,3.7-1.9c2,0,2.8,1.3,2.3,3.3l-1.8,6.6h-4.6l1.6-5.7
                c0.2-0.7,0.1-1-0.5-1c-0.6,0-0.9,0.2-1.2,1.1l-1.6,5.6h-4.6L58.9,15z"
              />
              <path
                class="st0"
                d="M79.5,21.4c-0.2,0.9-1.4,2.3-2.7,2.9c-1.4,0.6-2.7,0.7-3.7,0.7c-4.4,0-4.9-2-4-5.1c0.8-3.1,2.6-5.1,7-5.1
                c4.5,0,4.7,1.9,3.7,5.6h-6.5c-0.6,2-0.4,2.2,0.6,2.2c0.8,0,1.2-0.4,1.5-1.2H79.5z M76.2,18.6c0.2-0.8,0.2-1.6-0.8-1.6
                c-1,0-1.4,0.8-1.7,1.6H76.2z"
              />
              <path
                class="st0"
                d="M80.8,17.2l0.6-2.1h1l0.3-1.1c0.3-1,1.2-1.9,2.5-1.9h4.5l-0.6,2h-0.9c-0.7,0-1,0.2-1.2,1h7L93,17.2h-6.6
                l-2.1,7.5h-4.6l2.1-7.5H80.8z"
              />
              <polygon
                class="st0"
                points="89.4,15 93.9,15 91.3,24.6 86.8,24.6"
              />
              <polygon
                class="st0"
                points="89.6,14.2 90.2,12.1 94.8,12.1 94.2,14.2"
              />
              <path
                class="st0"
                d="M95.4,15l0.6-2.1h4.6L100,15h1.9l-0.6,2.1h-1.9l-1.1,4c-0.2,0.7,0.1,1.2,0.6,1.2h0.9l-0.6,2.3h-4.5
                c-1.3,0-1.7-1-1.5-1.9l1.5-5.5h-0.9l0.6-2.1H95.4z"
              />
              <path
                class="st0"
                d="M107.4,17.8c0.1-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.3-0.3-0.6-0.3c-0.6,0-0.9,0.2-1.1,0.8c-0.5,1.8,5.9-0.2,4.8,3.8
                c-0.6,2.3-2.3,3.5-6.1,3.5c-2.1,0-5-0.4-4.3-3.1h4.1c-0.1,0.3-0.1,0.5,0,0.7c0.1,0.2,0.3,0.3,0.6,0.3c0.6,0,1-0.4,1.1-0.7
                c0.5-1.7-5.6-0.3-4.6-4.1c0.6-2.2,2.2-3.2,5.8-3.2c3,0,4.9,0.5,4.2,3.1H107.4z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M112.7,12.1c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3
                C114,12.6,113.4,12.1,112.7,12.1L112.7,12.1z M112.7,14.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1
                C113.8,13.9,113.3,14.4,112.7,14.4"
              />
              <path
                class="st0"
                d="M113.2,13.1c0-0.3-0.2-0.4-0.5-0.4h-0.5V14h0.2v-0.5h0.2L113,14h0.3l-0.3-0.6
                C113.1,13.4,113.2,13.3,113.2,13.1L113.2,13.1z M112.5,13.3v-0.4h0.2c0.2,0,0.3,0,0.3,0.2c0,0.2-0.2,0.2-0.3,0.2H112.5"
              />
            </g>
            <polyline
              class="st0"
              points="7.5,9.8 4.1,9.8 6.8,0 13.8,0 13.1,2.3 9.5,2.3 9.1,4 12.7,4 12.1,6.1 8.5,6.1 7.5,9.8 "
            />
            <path
              class="st0"
              d="M15.4,9.8H12l2-7.1h3.4L15.4,9.8L15.4,9.8z M17.6,2h-3.4l0.5-2h3.4L17.6,2"
            />
            <path
              class="st0"
              d="M24.1,9.8h-3.3L21,9c-0.7,0.6-1.3,1-2.4,1c-1.1,0-1.8-0.5-1.8-1.6c0-1.2,0.5-3.1,1.2-4.3c0.5-1,1.5-1.5,2.6-1.5
              c1,0,1.7,0.4,1.9,0.9L23.5,0h3.4L24.1,9.8L24.1,9.8z M21.6,4.7c-0.3,0-0.6,0.1-0.8,0.5c-0.2,0.6-0.5,1.2-0.5,1.8
              c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.4-0.1,0.6-0.2L22.1,5C22,4.9,21.8,4.7,21.6,4.7"
            />
            <path
              class="st0"
              d="M33.7,6.6H29c-0.1,0.4-0.2,0.6-0.2,0.9c0,0.1,0,0.5,0.5,0.5c0.5,0,0.7-0.2,0.9-0.9h3.3c-0.4,2-2.8,2.7-4.3,2.7
              c-2,0-3.6-0.3-3.6-2.2c0-1.1,0.5-2.8,1.2-3.7c0.9-1.1,2.3-1.5,3.7-1.5c2.1,0,3.5,0.4,3.5,2.2C34,5.1,33.8,6.1,33.7,6.6L33.7,6.6z
               M30.3,4.3c-0.4,0-0.7,0.3-0.9,1h1.4c0-0.1,0.1-0.4,0.1-0.5C30.9,4.4,30.6,4.3,30.3,4.3"
            />
            <polyline
              class="st0"
              points="37,9.8 33.7,9.8 36.4,0 39.8,0 37,9.8 "
            />
            <path
              class="st0"
              d="M41.5,9.8h-3.4l2-7.1h3.4L41.5,9.8L41.5,9.8z M43.7,2h-3.4l0.5-2h3.4L43.7,2"
            />
            <path
              class="st0"
              d="M49.8,2.6L50,4.2h-2.6l-0.8,2.7c-0.1,0.2-0.1,0.5-0.1,0.6c0,0.3,0.1,0.4,0.6,0.4h0.7l-0.5,1.8h-3
              c-1,0-1.4-0.5-1.4-1.2c0-0.3,0-0.6,0.1-1L45,1h3.4l-0.4,1.6H49.8"
            />
            <path
              class="st0"
              d="M54.3,2.6l-1.8,4l0.1-4h-3.4l0.7,7.1c-0.1,0.4-0.2,0.7-0.5,0.8c-0.3,0.1-0.9,0.1-1.2,0.1l0,0l-0.5,1.9l2.3,0
              c1.4,0,2-0.7,3-2.2l4.9-7.7H54.3"
            />
          </svg>
        </div>
      </div>
      <div class="header-title">
        <p>
          {{ title }}
        </p>
      </div>
      <div
        class="header-login"
        hidden=""
      />
    </header>
  </div>
</template>

<script>
export default {
  name: 'NetBenefitsHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseURL: process.env.BASE_URL,
    };
  },
};
</script>

<style scoped>
  .st0{fill:#FFFFFF;}

  .nb-header {
    display:block;
    width:100%;
  }

  header {
    display:grid;
    display:-ms-grid;
    grid-template-rows:auto;
    -ms-grid-rows:100% 100%;
    grid-template-columns:75% 25%;
    -ms-grid-columns:75% 25%;
    background-color:#568200;
    padding:1em;
    align-items:center;
  }

  header a {
    text-decoration:none;
  }

  header p {
    padding-top:0;
    margin-top:0;
    color:#fff;
    display:inline-block;
    margin-bottom:0;
  }

  header .header-logo {
    grid-column:1;
    display:flex;
    align-items:center;
    -ms-grid-column:1;
    grid-row:1;
    -ms-grid-row:1;
  }

  header .header-logo a.header-home-link {
    line-height:1em;
    display:flex;
  }

  header .header-logo icon-set {
    color:#fff;
    width:7.125em;
    height:1.75em;
  }

  header .header-title {
    grid-row:2;
    -ms-grid-row:2;
    grid-column:span 2;
    -ms-grid-column:1;
    -ms-grid-column-span:2;
  }

  header .header-title p {
    font-size:1em;
    margin-bottom:0;
    line-height:1.375em;
    padding-top:.5em;
  }

  @media screen and (min-width: 32em) {
    header .header-title p {
      font-size:1.125em;
    }
  }

  @media screen and (min-width: 60em) {
    header .header-title p {
      font-size:1.3125em;
    }
  }

  header .header-login {
    grid-column:2;
    -ms-grid-column:2;
    grid-row:1;
    -ms-grid-row:1;
    text-align:right;
  }

  header .header-login a {
    font-size:.875em;
    display:flex;
    justify-content:flex-end;
    align-items:center;
    color:#fff;
  }

  @media screen and (min-width: 32em) {
    header .header-login a {
      font-size:1em;
    }

  }

  @media screen and (min-width: 60em) {
    header .header-login a {
      font-size:1.125em;
    }

  }

  header .header-login icon-set {
    width:1em;
    height:1em;
    fill:#fff;
    margin-right:0.5em;
  }

  @media screen and (min-width: 32em) {
    header {
      grid-template-rows:100%;
      -ms-grid-rows:100%;
      grid-template-columns:115px calc(100% - 215px) 100px;
      -ms-grid-columns:115px calc(100% - 215px) 100px;
    }

    header .header-title {
      grid-row:1;
      -ms-grid-row:1;
      grid-column:2;
      -ms-grid-column:2;
      -ms-grid-column-span:1;
      border-left:1px solid #fff;
      margin-left:0.5em;
      padding-left:1em;
    }

    header .header-title p {
      padding-top:0;
    }

    header .header-login {
      grid-column:3;
      -ms-grid-column:3;
    }
  }

  @media print {
    header {
      grid-template-rows:100%;
      -ms-grid-rows:100%;
      grid-template-columns:115px calc(100% - 115px);
      -ms-grid-columns:115px calc(100% - 115px);
      background-color:#fff;
    }

    header p {
      color:#000;
    }

    header .header-title {
      grid-row:1;
      -ms-grid-row:1;
      grid-column:2;
      -ms-grid-column:2;
      -ms-grid-column-span:1;
      border-left:1px solid #000;
      margin-left:0.5em;
      padding-left:1em;
    }

    header .header-title p {
      padding-top:0;
    }

    header .header-logo icon-set {
      fill:#000;
    }

    header .header-login {
      display:none;
    }
  }
</style>
